import { Helmet } from "react-helmet-async";

const SITE = "To-Let Rentals";
const DEFAULT_OG = "https://images.unsplash.com/photo-1669548329838-45008f9a45fc?w=1200&h=630&fit=crop";

/**
 * Reusable SEO head for any page.
 * <SEO title="…" description="…" path="/properties" image="…" breadcrumbs={[…]} schema={…} faqs={[{q, a}]} />
 */
export default function SEO({ title, description, path = "", image, keywords, breadcrumbs = [], schema, faqs, canonical }) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Rent or buy homes directly from owners`;
  const desc = description || "Rent or buy homes in India directly from verified owners. Zero brokerage, free listings, AI rent estimator, verified owner badges.";
  const url = `https://to-let-rentals.com${path}`;
  const img = image || DEFAULT_OG;
  const canonicalUrl = canonical || url;

  const breadcrumbSchema = breadcrumbs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((b, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": b.name,
      "item": `https://to-let-rentals.com${b.path}`,
    })),
  } : null;

  const faqSchema = faqs && faqs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(({ q, a }) => ({
      "@type": "Question",
      "name": q,
      "acceptedAnswer": { "@type": "Answer", "text": a },
    })),
  } : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
      {faqSchema && (
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      )}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
